<template src="../templates/cattleLog.pug" lang="pug"></template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { format, parse } from 'date-fns'

    export default {
        name: "CattleLog",
        data() {
            return {
                format
            }
        },
        computed: {
            ...mapGetters([
                'logs',
                'filterActions'
            ])
        },
        mounted() {
            this.fetchLogs()
        },
        methods: {
            ...mapMutations(['updateFilterAction']),
            ...mapActions(['fetchLogs'])
        }
    }
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #cattle-log
        table
            .table-header
                background-color: $dd-very-dark-gray
</style>
